import { useCallback, useEffect } from "react";
import { useAppContext, useService } from "../../../../hooks";

export const usePremiumServices = () => {
  const {
    actions: { setServices },
    selectors: { getServices },
  } = useAppContext();
  const { getServices: fetchServices } = useService("Service");

  const getServicesData = useCallback(async () => {
    const result = await fetchServices();
    if (result.status) {
      if (result.data?.length !== 0) {
        setServices(result.data);
      }
    }
  }, [setServices]);

  useEffect(() => {
    if (getServices().length === 0) {
      getServicesData();
    }
  }, []);

  return {
    serviceList: getServices().filter(
      (item) => item.status === "publish" && item.isFeatured === "true"
    ),
  };
};
